import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import leagueWSManager from 'utils/LeagueWebSocketManager/LeagueWebSocketManager';
import { UseLeagueWSParams } from './types';

export const useLeagueWS = ({
  leagueId,
  matchId,
  match,
  refetchMatch,
  refetchRuns,
}: UseLeagueWSParams) => {
  const dispatch = useDispatch();

  // setup socket once match is loaded
  useEffect(() => {
    if (leagueId && matchId && match && !leagueWSManager.isConnected()) {
      leagueWSManager.setupLeagueSocket(dispatch, {
        leagueId,
        matchId,
        startDate: match.start_date,
        endDate: match.end_date,
      });
    }
  }, [
    match?._etag, // ensure single execution when match data is loaded
  ]);

  // on WS open → refetch match, then runs
  useEffect(() => {
    leagueWSManager.setOnOpen(async () => {
      try {
        const matchResult = await refetchMatch();
        if ('error' in matchResult || !matchResult.data) return;
        if (matchResult.data) await refetchRuns();
      } catch (e) {
        console.error('Sequential refetch error:', e);
      }
    });
  }, [refetchMatch, refetchRuns]);

  // on every WS message → refetch runs
  useEffect(() => {
    leagueWSManager.setOnMessage(() => {
      refetchRuns();
    });
  }, [refetchRuns]);

  // cleanup on unmount
  useEffect(() => {
    return () => {
      leagueWSManager.closeSocket();
    };
  }, []);
};
